var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "velaJsQty",
      class: _vm.styleModifier ? `quantity--${_vm.styleModifier}` : "",
    },
    [
      _c(
        "button",
        {
          staticClass: "velaQtyAdjust velaQtyAdjustMinus",
          attrs: { "aria-label": "Decrement quantity", type: "button" },
          on: {
            click: function ($event) {
              return _vm.handleUpdateQuantity(_vm.quantity - 1)
            },
          },
        },
        [_c("span", { staticClass: "txtFallback" })]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.quantity,
            expression: "quantity",
          },
        ],
        staticClass: "velaQtyNum",
        attrs: { id: "Quantity", "aria-label": "Quantity", type: "number" },
        domProps: { value: _vm.quantity },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) return
              _vm.quantity = $event.target.value
            },
            _vm.handleQuantityInput,
          ],
        },
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "velaQtyAdjust velaQtyAdjustPlus",
          attrs: { "aria-label": "Increment quantity", type: "button" },
          on: {
            click: function ($event) {
              return _vm.handleUpdateQuantity(_vm.quantity + 1)
            },
          },
        },
        [_c("span", { staticClass: "txtFallback" })]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }